export default __webpack_public_path__ + "static/media/LogoRSPS.37b8375a.png";